import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: startDate => ({
        date: Math.floor(startDate / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'itsmDetailsTickets',
        endpoint:           endpoints.itsm.detailsTickets,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => ({
            results: !response.results ? [] : response.results.map(item => ({
                descState:        item.desc_state,
                orderNumber:      item.order_number,
                descType:         item.desc_type,
                descUrgency:      item.desc_urgency,
                descImpact:       item.desc_impact,
                lastUpdated:      item.last_updated,
                openedBy:         item.opened_by,
                shortDescription: item.short_description,
                opened:           item.opened,
                responseTime:     item.response_time,
                resolutionTime:   item.resolution_time
            }))
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/itsmDetailsTickets.js